import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { business } from "../config/business";

// Canonical is derived from the actual current route by default so a page's
// declared canonical can never drift out of sync with its real URL again.
const SEOHead = ({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  noindex = false,
}) => {
  const location = useLocation();
  const resolvedCanonical = canonical || `${business.siteUrl}${location.pathname}`;
  const resolvedOgImage = ogImage || `${business.siteUrl}/logo.png`;

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={resolvedCanonical} />

      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={resolvedCanonical} />
      <meta property="og:image" content={resolvedOgImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={resolvedOgImage} />
    </Helmet>
  );
};

export default SEOHead;
